import React, { useRef, useState, useEffect } from 'react'
import AdminAssets from './AdminAssets'
import AdminSidebar from './AdminSidebar'
import { useNavigate } from 'react-router-dom'
import axios from '../../utils/axiosInstance';

const AdminSuccessStories = () => {

  const [successstories, setSuccessStories] = useState([]);
  const [formData, setFormData] = useState({
    name: "",    
    designation: "",
    company: "",
    image: "",
    youtubelink: "",
  });

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  
  // useEffect(() => {
  //       axios.get(`${process.env.REACT_APP_API_BASE}/admin/session`, {
  //           withCredentials: true,
  //       }).then((res) => {
  //           setLoading(false); // only load dashboard if logged in
  //           fetchSuccessStories();
  //       }).catch(() => {
  //           navigate('/admin'); // fallback redirect on error
  //       });
  // }, [navigate]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE}/admin/session`)
      .then((res) => {
        if (!res.data.loggedIn) {
          navigate('/admin');
        } else {
          setLoading(false);
          fetchSuccessStories();
        }
      })
      .catch(() => {
        navigate('/admin');
      });
  }, [navigate]);

  const fetchSuccessStories = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE}/success`);
      setSuccessStories(response.data);
    } catch (error) {
      console.error('Error fetching success stories:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this Success Story ?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE}/success/${id}`);
        setSuccessStories((prev) => {
          const updated = prev.filter((e) => e._id !== id);

          return updated;
        });
        window.location.reload();
      } catch (error) {
        console.error('Failed to delete blogs:', error);
      }
    }
  };

  const handleImageChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      image: e.target.files[0], // store the File object
    }));
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const fileInputRef = useRef(null); // ref for the file input

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevents page refresh

    const form = new FormData();

    // const formattedDate = new Date(formData.date).toLocaleDateString("en-IN", {
    //   year: "numeric",
    //   month: "long",
    //   day: "numeric",
    // });

    form.append("name", formData.name);
    form.append("designation", formData.designation);
    form.append("company", formData.company);
    form.append("youtubelink", formData.youtubelink);
    if (formData.image) {
      form.append("image", formData.image);
    }
    

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/success`, {
        method: "POST",
        body: form, 
      });

      const result = await response.json();

      if (response.ok) {
        alert("Success Stories submitted!");
        setFormData({
          name: "",          
          designation: "",
          company: "",
          image: "",
          youtubelink: "",
        });

        // Clear the file input manually
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        alert(result.error || "Failed to submit succees stories");
      }
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Error submitting succees stories");
    }
  };

  if (loading) return null;

  return (
    <div>
        <AdminAssets />
        <AdminSidebar/>

        <section className="content">
          <div className="container-fluid mt-5">
            <div className="row">
              <div className="col-sm-2"></div>
              <div className="col-sm-8">
                  <div className="card shadow">
                    <div className="card-header text-start">
                      <h3 className="mb-0">Add Success Stories</h3><br/>
                    </div>
                    <div className="card-body text-start">
                      <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                          <label htmlFor="name" className="form-label">
                            Name:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label htmlFor="image" className="form-label">
                            Photo:
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="image"
                            name="image"
                            onChange={handleImageChange}
                            ref={fileInputRef}
                          />
                        </div>

                        <div className="mb-3">
                          <label htmlFor="author" className="form-label">
                            Designation:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="designation"
                            name="designation"
                            value={formData.designation}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label htmlFor="author" className="form-label">
                            Company:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="company"
                            name="company"
                            value={formData.company}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label htmlFor="youtubelink" className="form-label">
                            YouTube Link:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="youtubelink"
                            name="youtubelink"
                            value={formData.youtubelink}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <button type="submit" className="btn btn-success w-100">
                          Submit Success Story
                        </button>
                      </form>
                    </div>
                  </div>

              </div>
              <div className="col-sm-2"></div>
            </div>



            <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="card">
                <div className="header">
                  <h2 className='fw-bold text-start'>Success Stories</h2>
                </div>
                <div className="body">
                  {successstories.length === 0 ? (
                    <p>No Success Stories Found.</p>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover">
                          <thead>
                            <tr>
                              <th>Action</th>
                              <th>Name</th>
                              <th>Designation</th>
                              <th>Company</th>
                              <th>Image</th>
                              <th>YouTube Link</th>
                            </tr>
                          </thead>
                          <tbody>
                            {successstories.map((successstories, index) => (
                              <tr key={successstories._id}>
                                <td>
                                  <button
                                    className="btn btn-danger waves-effect"
                                    onClick={() => handleDelete(successstories._id)}
                                  >
                                    Delete
                                  </button>
                                </td>
                                <td>{successstories.name}</td>
                                <td>{successstories.designation}</td>
                                <td>{successstories.company}</td>
                                <td>
                                    <img
                                        // src={`http://localhost:5002/uploads/blog/${blogs.image}`}
                                        src={`${process.env.REACT_APP_API_BASE}/uploads/successStory/${successstories.image}`}
                                        alt="Blog"
                                        style={{ width: '80px', height: 'auto', objectFit: 'cover' }}
                                    />
                                </td>
                                <td>{successstories.youtubelink}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
            
          </div>
        </section>
    </div>
  )
}

export default AdminSuccessStories